import template from './mapLocationPage.html';
import controller from './mapLocationPage.controller';
import './mapLocationPage.scss';

let mapLocationPageComponent = {
  restrict: 'E',
  bindings: {
    filters: '<',
    locations: '<'
  },
  template,
  controller
};

export default mapLocationPageComponent;
